module.exports = __webpack_public_path__ + "static/Fellix-Bold-9baac3a577375fdce703161967d556be.woff2";